export default __webpack_public_path__ + "static/cg42-46c5ba959446d2a9b21b0b915d29f685.jpg";